/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Our_3Inputs */



/**
* | output |
* | --- |
* | "Logging of all filtering decisions in audit logs" |
*
* @param {Guardrails_Section_3_Our_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_our_3 = /** @type {((inputs?: Guardrails_Section_3_Our_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Our_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Protokollierung aller Filterentscheidungen im Audit-Log")
	return /** @type {LocalizedString} */ ("Logging of all filtering decisions in audit logs")
});